module.exports = __webpack_public_path__ + "img/contrology-atc@2x.dda00f6d.png";